'use client';

import { SessionProvider, useSession } from 'next-auth/react';
import { usePathname } from 'next/navigation';
import { Skeleton } from '@core/ui/skeleton';
import { Button } from 'rizzui';
import { PiLockKeyBold, PiSignInBold } from 'react-icons/pi';
import { LandingLink as Link } from '@/app/shared/landing/components/landing-link';
import AvailableLoadsWorkspace from '@/app/shared/available-loads';

function AvailableLoadsLoading() {
  return (
    <section className="available-loads-board available-loads-board--auth ss-section ss-section--soft">
      <div className="container">
        <div className="available-loads-board__auth-card">
          <Skeleton className="h-11 w-11 rounded-2xl" />
          <div className="min-w-0 flex-1">
            <Skeleton className="h-6 w-64 max-w-full rounded-md" />
            <Skeleton className="mt-3 h-4 w-[32rem] max-w-full rounded-md" />
          </div>
        </div>
      </div>
    </section>
  );
}

function AvailableLoadsSignInGate() {
  const pathname = usePathname() || '/en/carriers/available-loads';
  const signInHref = `/auth/sign-in?callbackUrl=${encodeURIComponent(pathname)}`;

  return (
    <section className="available-loads-board available-loads-board--auth ss-section ss-section--soft">
      <div className="container">
        <div className="available-loads-board__auth-card">
          <span className="available-loads-board__auth-icon" aria-hidden="true">
            <PiLockKeyBold />
          </span>
          <div className="available-loads-board__auth-copy">
            <span>Carrier access required</span>
            <h2>Sign in to view current available loads.</h2>
            <p>
              Logged-in carrier and operations users can review the live load
              board from this landing page or from the dashboard workspace.
            </p>
          </div>
          <Link href={signInHref} className="available-loads-board__auth-link">
            <Button
              as="span"
              className="available-loads-board__auth-button"
            >
              <PiSignInBold aria-hidden="true" />
              Sign in
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}

function AvailableLoadsAccessContent() {
  const { status } = useSession();

  if (status === 'loading') return <AvailableLoadsLoading />;
  if (status !== 'authenticated') return <AvailableLoadsSignInGate />;

  return <AvailableLoadsWorkspace isLanding />;
}

export function AvailableLoadsAccess() {
  return (
    <SessionProvider>
      <AvailableLoadsAccessContent />
    </SessionProvider>
  );
}
